var exports = {
  "kL": "xa15a2ab7--434ff4--container",
  "pU": "xa15a2ab7--434ff4--iframe",
  "VN": "xa15a2ab7--434ff4--close",
  "u1": "xa15a2ab7--434ff4--spinner",
};

module.exports = exports;
